export function Button(props: { title: string; onClick: () => void; onclick: () => void }) {
  return (
    <div class=" h-44px bg#p max-w-max cursor-pointer">
      <p class="text-white text-16px py-10px px-20px" onClick={props.onClick} onclick={props.onclick}>
        {props.title}
      </p>
    </div>
  );
}
